/** @format */
import { MarketSlug } from '@mpb-com/feather/enums';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const IDP_FORGOTTEN_PASSWORD_PATH = '/auth/oauth/forgotten-password';

// Valid canonical tags BCP 47 (RFC 5646) — the IdP 404s on anything else.
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const IDP_LOCALES = [
    'en-GB',
    'en-150', // english for Europe
    'en-IE',
    'en-US',
    'de-DE',
    'de-AT',
    'fr-FR',
    'fr-BE',
    'nl-NL',
    'nl-BE',
    'it-IT',
    'es-ES',
    'pt-PT',
] as const;

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type IdpLocale = (typeof IDP_LOCALES)[number];

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const IDP_LOCALE_BY_MARKET_SLUG: Record<MarketSlug, IdpLocale> = {
    [MarketSlug.EN_UK]: 'en-GB',
    [MarketSlug.EN_EU]: 'en-150',
    [MarketSlug.EN_IE]: 'en-IE',
    [MarketSlug.EN_US]: 'en-US',
    [MarketSlug.DE_DE]: 'de-DE',
    [MarketSlug.DE_AT]: 'de-AT',
    [MarketSlug.FR_FR]: 'fr-FR',
    [MarketSlug.FR_BE]: 'fr-BE',
    [MarketSlug.NL_NL]: 'nl-NL',
    [MarketSlug.NL_BE]: 'nl-BE',
    [MarketSlug.IT_IT]: 'it-IT',
    [MarketSlug.ES_ES]: 'es-ES',
    [MarketSlug.PT_PT]: 'pt-PT',
};
